"use client";
import * as React from "react";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  className?: string;
};

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className = "", ...props }, ref) => (
  <textarea
    ref={ref}
    className={
      [
        "block w-full rounded-md border bg-background text-foreground",
        "border-input px-3 py-2 text-sm outline-none",
        "focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:border-ring",
        "placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        className,
      ].join(" ")
    }
    {...props}
  />
));
Textarea.displayName = "Textarea";

export default Textarea;
